
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class CaptionComponent extends Vue {
    @Prop() readonly caption!: string

    data: {showCopyToClipboard: boolean} = {showCopyToClipboard: false}

    get showCopyToClipboard(): boolean {
        return this.data.showCopyToClipboard;
    }

    // Copies the caption text to users clipboard
    copyCaptionClick(): void {
        $('.clipboard-popover').popover('show');
        navigator.clipboard.writeText(this.caption);

        setTimeout(function(){
            $('.clipboard-popover').popover('hide');
        }, 2500);
    }

    created(): void{
        this.data.showCopyToClipboard = !!navigator.clipboard;     
    }

    mounted(): void{
           $('.clipboard-popover').popover({
                placement: "top",
                trigger: "click",
                content: "Caption copied to clipboard"
            });
    }
}
